import { AutocompleteOption } from '@/Components/shadcn';
import { DefaultSkillsOptionsDTO } from '@/DTO/Assessments/DefaultSkillsOptionsDTO';
import AutocompleteOptionType from '@/Models/AutocompleteOptionType';
import { get } from '@/Utils/HTTP/HttpUtils';
import ClientBase from './ClientBase';

const isJobFunctionHardSkillsDisabled = (jobFunctionId: number) => {
    switch (jobFunctionId) {
        case 13: // Information Technology: General software development
        case 19: // Accounting: Other Accounting functions
        case 22: // Digital Marketing: Performance Marketing
        case 25: // Digital Marketing: Other Digital Marketing functions
        case 30: // Human Resources: Other Human Resources functions
        case 43: // Finance: Other Finance functions
        case 44: // Construction: Project Management
        case 51: // Information Technology: IT Infrastructure
        case 52: // Information Technology: Quality Assurance
        case 55: // Logistics and Supply Chain: Other Logistics and Supply Chain functions
        case 58: // Manufacturing: Other Manufacturing functions
        case 61: // Finance: Financial Analysis
        case 67: // Facilities Management: Other Facilities Management functions
        case 73: // Sales: Other Sales functions
        case 75: // Retail: Other Retail functions
        case 77: // Customer Service: Other Customer Service functions
        case 81: // Administrative: Other Administrative functions
            return true;
        default:
            return false;
    }
};

export default class AutocompleteOptionsClient extends ClientBase {
    prefix = 'questions/autocomplete-options';

    async getAutocompleteOptions(
        search: string,
        optionType: AutocompleteOptionType,
        limit?: number,
    ): Promise<AutocompleteOption[]> {
        const response = await get<AutocompleteOption[]>({
            path: this.addHost(`${this.prefix}?${this.buildAutocompleteOptionsSearchQuery(search, optionType, limit)}`),
            accessToken: await this.getAccessTokenSilently(),
        });
        if (response.ok && response.body) {
            return response.body;
        }

        return [];
    }

    buildAutocompleteOptionsSearchQuery(search: string, optionType: AutocompleteOptionType, limit?: number): string {
        const query = new URLSearchParams({
            search,
            type: optionType.toString(),
        });

        if (limit) {
            query.append('limit', Math.min(limit, 50).toString());
        }

        return query.toString();
    }

    async getDefaultSkillsOptions(jobFunctionId: number): Promise<DefaultSkillsOptionsDTO> {
        const response = await get<DefaultSkillsOptionsDTO>({
            path: this.addHost(`${this.prefix}/default-skills?jobFunctionId=${jobFunctionId}`),
            accessToken: await this.getAccessTokenSilently(),
        });
        if (response.ok && response.body) {
            const result = response.body;

            if (isJobFunctionHardSkillsDisabled(jobFunctionId)) {
                result.hardSkills = [];
            }

            return result;
        }

        return { hardSkills: [], softSkills: [] } as DefaultSkillsOptionsDTO;
    }
}
